// M4 world: handlers for the dormant M4 news effect types (docs/M4_SPEC.md §0) — stormM4, leaseRoundM4, megaprojectM4,
// nationalizationM4, sanctionM4, regimeM4, moratorium, opecQuota, takeaway, seismicity, freeze, wildfire — on
// item.effect and item.m4Effect, plus regionEvent carried in m4Effect for the six M4 regions. Informational effects
// are recorded in state.m4w.fx for the other workstreams: fx.opec [{ day, mbd }], fx.takeaway { zone: day } (B),
// fx.seismicity { regionId: { day, mag } } (A), fx.sanctions { id: day }, fx.regimes { id: day }, fx.moratorium.
import { HISTORICAL_STORMS_M4 } from '../../data/m4/rules.js';
import { applyRegionEvent } from '../m2/politics.js';
import { regionDef } from '../defs.js';
import { W, m4On } from './worldCore.js';
import { stormShutIns, openLeaseRoundM4, applyM4Nationalization, applyFreeze, applyWildfire } from './worldPolitics.js';
import { applyMegaNews } from './worldMega.js';

export const M4_WORLD_EFFECTS = new Set(['stormM4', 'leaseRoundM4', 'megaprojectM4', 'nationalizationM4', 'sanctionM4', 'regimeM4', 'moratorium', 'opecQuota', 'takeaway', 'seismicity', 'freeze', 'wildfire']);

export function applyM4WorldNewsEffect(state, item, { replay = false } = {}) {
  if (!item || !m4On(state)) return;
  const day = replay ? item.day : state.day;
  for (const [slot, e] of [['effect', item.effect], ['m4Effect', item.m4Effect]]) {
    if (!e) continue;
    if (e.type === 'regionEvent') { if (slot === 'm4Effect' && !replay && regionDef(e.regionId) && state.regions?.[e.regionId]) applyRegionEvent(state, { ...item, effect: e }); continue; }
    if (!M4_WORLD_EFFECTS.has(e.type)) continue;
    const fx = W(state).fx;
    switch (e.type) {
      case 'stormM4': { const hs = HISTORICAL_STORMS_M4.find((s) => s.id === e.stormId); if (hs && !replay) stormShutIns(state, hs); break; }
      case 'leaseRoundM4': if (!replay) openLeaseRoundM4(state, e.roundId); break;
      case 'megaprojectM4': applyMegaNews(state, e.id, e.phase, day, { silent: replay }); break;
      case 'nationalizationM4': if (!replay) applyM4Nationalization(state, e.id); break;
      case 'sanctionM4': (fx.sanctions ??= {})[e.id] = day; break;
      case 'regimeM4': (fx.regimes ??= {})[e.id] = day; break;
      case 'moratorium': fx.moratorium = { regionId: e.regionId, minWaterFt: e.minWaterFt ?? 500, active: !!e.active, day }; break;
      case 'opecQuota': (fx.opec ??= []).push({ day, mbd: e.mbd }); if (fx.opec.length > 40) fx.opec.splice(0, fx.opec.length - 40); break;
      case 'takeaway': (fx.takeaway ??= {})[e.zone] = day; break;
      case 'seismicity': (fx.seismicity ??= {})[e.regionId] = { day, mag: e.mag }; break;
      case 'freeze': if (!replay) applyFreeze(state, e); break;
      case 'wildfire': if (!replay) applyWildfire(state, e); break;
      default: break;
    }
  }
}
